import React, { useState, useEffect } from "react";
import {
  postDestino as addDestino,
} from "../helpers/rutaDestinos";

import { getLocalidades } from "../helpers/rutaLocalidades";
import { getRutas } from "../helpers/rutaRutas";
import { getIva } from "../helpers/rutaIva";
import "../css/addclienteform.css";
import { Modal, Button } from "react-bootstrap";
import 'animate.css';

const AddDestinoForm = ({ setShow }) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [formValues, setFormValues] = useState({
    coddes: "",
    destino: "",
  });

  const handleChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const resp = await addDestino(formValues);
      console.log("✅ Destino creado:", resp);

      setShowSuccess(true); // Mostrar modal de éxito

      setTimeout(() => {
        setShowSuccess(false); // Ocultarlo

        setFormValues({
          coddes: "",
          destino: "",
        });

        // Si querés cerrar el modal también:
        // setShow(false);
      }, 2000);
    } catch (error) {
      console.error("❌ Error al crear destino:", error);
      // Modal de error opcional acá
    }
  };


  // const [localidades, setLocalidades] = useState({ data: {}, loading: true });
  // const [iva, setIva] = useState({ data: {}, loading: true });
  // const [rutas, setRutas] = useState({ data: {}, loading: true });

  // useEffect(() => {
  //   getLocalidades().then((localidades) =>
  //     setLocalidades({ data: localidades, loading: false })
  //   );
  //   getIva().then((iva) => setIva({ data: iva, loading: false }));
  //   getRutas().then((rutas) => setRutas({ data: rutas, loading: false }));
  // }, []);

  return (
    <>
        <div className="container">
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group mt-3 col-sm-5">
                <label>Destino</label>
                <input
                  type="text"
                  className="form-control"
                  name="destino"
                  maxLength="100"
                  required
                  value={formValues.destino}
                  onChange={handleChange}
                />
              </div>


            </div>


            <div>
              <button
                type="submit"
                className="btn btn-dark mt-5 mb-3"
                id="button"
              >
                Guardar
              </button>
            </div>
          </form>
        </div>
  
        <Modal
          show={showSuccess}
          centered
          backdrop="static"
          keyboard={false}
          dialogClassName="animate__animated animate__fadeInDown"
        >
          <Modal.Body className="text-center">
            <div style={{ fontSize: "3rem" }}>🖐</div>
            <h5 className="mt-2">¡Registro generado correctamente!</h5>
            </Modal.Body>
        </Modal>
      </>

  );
};

export default AddDestinoForm;
